<template>
  <div class="container">
    <!-- <router-link to="/about" id="about" class="link">About</router-link> -->
    <GitLogo class="icon" href='https://github.com/Carnaux'></GitLogo>
    <LinkedinLogo class="style2" href='https://www.linkedin.com/in/daniel-fernandes-101853138/'></LinkedinLogo>
  </div>
</template>

<script>
import GitLogo from './GitLogo';
import LinkedinLogo from './LinkedinLogo';

export default {
  name: 'Header',
  components: {
    GitLogo,
    LinkedinLogo
  },
  props: {}
}
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

  .icon{
    width: auto;
    height: 10px;
    margin-bottom: 15px;
  }
  .style2{
    width: auto;
    height: 10px;
    margin-left: 5px;
    margin-bottom: 15px;
  }
  .link{
    font-family: 'Bebas Neue', cursive;
    text-align: center;
    margin-right: 15px;
    text-decoration: none;
    color: black;
    font-size: 45px;
  }
  .link:hover{
    color: rgb(100, 100, 100)
  }
  .container{
    width: 100%;
    height: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
